exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-app[data-v-29087cdd]{font-size:16px;height:100px}.btn-add-dc[data-v-29087cdd]{padding:30px}.cross[data-v-29087cdd]{position:absolute;top:0;right:0;color:#da8989}", ""]);

// exports
